import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import {
    faLinkedin,
    faFacebook,
    faInstagram,
    faGithub
} from "@fortawesome/free-brands-svg-icons";
import { motion } from "framer-motion";
import "animate.css";

function Developer() {
    return (
        <motion.div
            className="container my-5 animate__animated animate__fadeIn"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
        >

            <header className="container">
                <div className="row">
                    <div className="col">
                        <div className="text-left mb-5">
                            <h1 className="fw-bold text-primary">Khizer Shafi</h1>
                            <p className="text-muted fs-5">Graphic Designer | Web Developer</p>
                            {/* Social Media Icons */}
                            <div className="d-flex justify-content-left gap-3 mt-3">
                                {/*    <a href="mailto:khizershafi6@gmail.com" className="text-primary fs-4">
                                    <FontAwesomeIcon icon={faEnvelope} />
                                </a> */}
                                <a href="https://www.linkedin.com/in/khizershafi" className="text-primary fs-4">
                                    <FontAwesomeIcon icon={faLinkedin} />
                                </a>
                                <a href="https://www.facebook.com/khizershafi" className="text-primary fs-4">
                                    <FontAwesomeIcon icon={faFacebook} />
                                </a>
                                <a href="https://www.instagram.com/khizershafi" className="text-danger fs-4">
                                    <FontAwesomeIcon icon={faInstagram} />
                                </a>
                                <a href="https://github.com/khizershafi" className="text-dark fs-4">
                                    <FontAwesomeIcon icon={faGithub} />
                                </a>
                            </div>


                        </div>
                    </div>


                    <div className="col-6 justify-content-right">
                        <img
                            src="images/profile.jpg"
                            alt="Khizer Shafi Graphic Designer"
                            className="rounded-circle shadow img-fluid"
                            style={{ width: "120px", height: "120px", objectFit: "cover" }}
                        />
                    </div>

                </div>



            </header>

            {/* Contact Section */}
            <motion.section
                className="mb-4 animate__animated animate__fadeInUp"
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
            >
      
            </motion.section>

            {/* Skills Section */}
            <motion.section
                className="mb-4 animate__animated animate__fadeInUp"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
            >
                <div className="row">
                    <div className="col col-md-6">
                        <h2 className="text-primary">Objective</h2>
                        <p> I am a Computer Science enthusiast
                            with a strong academic background,
                            Alongside my studies, I actively
                            participated in co-curricular activities,
                            enhancing my teamwork skills.
                            Experienced in graphic designing with a
                            growing interest in web development.</p>
                    </div>

                    <div className="col-12 col-md-6">
                        <h2 className="text-primary">Education</h2>
                        <h6>GOVT. GRADUATE COLLEGE</h6>
                        <p>    Intermediate   <br></br></p>
                       <h6>THE ISLAMIA UNIVERSITY BAHAWALPUR </h6> 
                       <p>   Bachelors Of Science in Computer Science    <br></br></p>
                    </div>
                </div>


                <h2 className="border-bottom pb-2 text-primary">Skills</h2>


                <div className="row">

                    {/* Web Development Skills */}
                    <div className="col-md-6">
                        <h4 className="text-success">Web Development</h4>
                        <ul className="list-group">
                            <li className="list-group-item">React.js</li>
                            <li className="list-group-item">Node.js</li>
                            <li className="list-group-item">Express.js</li>
                            <li className="list-group-item">MongoDB</li>
                            <li className="list-group-item">Bootstrap</li>
                        </ul>
                        <div>
                        <h5 className="mt-3">Projects</h5>
                        <ul className="list-group">
                            <li className="list-group-item">Semester Level Projects</li>
                            <li className="list-group-item">Frontend Single Page App</li>
                            <li className="list-group-item">CRUD App in MERN Stack</li>
                            <li className="list-group-item">CRUD App in Django Framework</li>
                            <li className="list-group-item">Multiple Users based website</li>
                        
                        </ul>
                        </div>

                        <h4 className="mt-3">Sample Projects</h4>
                        <p className="text-secondary">Links will be uploaded Here Soon...</p>
                    </div>

                    {/* Graphic Design Skills */}
                    <div className="col-md-6">
                        <h4 className="text-primary">Graphic Design</h4>

                        {/* Tools Section */}
                        <h5 className="text-dark mt-3">Tools</h5>
                        <ul className="list-group">
                            <li className="list-group-item">CorelDRAW</li>
                            <li className="list-group-item">Adobe Illustrator</li>
                            <li className="list-group-item">Canva</li>
                            <li className="list-group-item">Adobe Photoshop</li>
                          
                        </ul>

                        {/* Design Skills Section */}
                        <h5 className="text-dark mt-3">Design Skills</h5>
                        <ul className="list-group">
                            <li className="list-group-item">Poster Designing</li>
                            <li className="list-group-item">Banner Designing</li>
                            <li className="list-group-item">Visiting Card Designing</li>
                            <li className="list-group-item">Social Media Banners</li>
                            <li className="list-group-item">YouTube Thumbnails</li>
                            <li className="list-group-item">Custom Invitations & Event Designs</li>
                        </ul>
                    </div>

                </div>
                <div className="row">
                    <div className="col-12 mt-3 mb-3 text-center">
                        <a target="_blank" href="https://drive.google.com/drive/folders/1R-dOEePf1uoO2O17yOqdoxKbqqi401f7?usp=drive_link">    <button className="btn btn-lg btn-primary"  >Click Here to View my Portoflio</button></a>
                    </div>
                </div>
            </motion.section>

        </motion.div>
    );
}

export default Developer;




